import React from 'react'
import columns from '../schemas/columns.json'
import ColumnItem from '../components/ColumnItem'

function useGetColumns({ actions = [] }) {
	//TODO: Get columns from Redux when column.json comes from database

	const tableColumns = columns.map((column) => {
		const hasActions = column.type === 'action'
		return {
			title: column.title,
			dataIndex: column.key.split('.'),
			key: `${column.id}-${column.key}`,
			render: (content, row) => (
				<ColumnItem
					column={hasActions ? { ...column, actions } : column}
					row={row}
					content={content}
				/>
			),
		}
	})

	return tableColumns
}

export default useGetColumns
